/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import purchaseService from './../../../../services/purchase';
import accountService from './../../../../services/account';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';
import store from './../../../../store';
import BridgeHandoffMixin from './../../../../mixins/bridgeHandoff';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
      info: 'info',
      primary: 'primary',
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      purchases: 'paginatePurchases',
      view: 'getView',
    }),

    purchasesListView() {
      return this.purchases.items.map(c => ({
        code: c.code,
        name: c.name,
        warehouse: c.warehouseName,
        supplier: c.supplierName,
        createdAt: c.createdAt,
        comments: c.comments,
        status: c.purchaseStatus.name,
        id: c.id,
        qty: c.total_qty,
      }));
    },

    purchasesList() {
      return this.purchases.items.map(b =>
       /* let cardClass = '';

        if (b.billStatus === 'Overdue') {
          cardClass = 'card-red';
        } else if (b.billStatus === 'Cleared') {
          cardClass = 'card-green';
        } else if (b.billStatus === 'Sent') {
          cardClass = 'card-yellow';
        }

        Object.assign(b, {
          number: b.billingNumber ? `#${b.billingNumber}` : 'Draft',
          value: `${b.totalValue.toFixed(2)} NOK`,
          amount: `(${b.totalQuantity} ${this.$t('static.bills.index.quantities')})`,
          dueDateFormated: moment(b.dueDate).isValid() ? moment(b.dueDate).format('DD-MM-YYYY') : '-',
          cardClass,
        });*/

         b);
    },
  },

  watch: {

    view(view) {
      console.log(view);
      if (view == 'card') {
        this.info = 'info';
        this.primary = 'primary';
      } else {
        this.primary = 'info';
        this.info = 'primary';
      }
    },
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, 50);
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
    VTable: require('./../../../../components/table/table.vue'),
  },

  mixins: [
    SearchMixin,
    BridgeHandoffMixin,
  ],

  mounted() {
    this.setInnerSidebar([
      {
        title: this.$t('static.inventory.transaction.title'),
        options: [
          {
            title: this.$t('static.stock.filters.title'),
            route: {
              name: 'inventory.stock.index',
            },
          },
          {
            title: this.$t('static.adjustment.filters.title'),
            route: {
              name: 'inventory.adjustment.index',
            },
          },
          {
            title: this.$t('static.purchase.filters.title'),
            route: {
              name: 'inventory.purchase.index',
            },
          },
          {
            title: this.$t('static.transfer.filters.title'),
            route: {
              name: 'inventory.transfer.index',
            },
          },
        ],
        button: this.bridgeStockWriteBlocked ? null : {
          title: `+ ${this.$t('static.warehouse.addTransaction.title')}`,
          route: {
            name: 'inventory.transaction.index',
          },
        },
      },

      {
        title: this.$t('static.warehouse.filters.title'),
        options: [
          {
            title: this.$t('static.warehouse.filters.view'),
            route: {
              name: 'warehouse.index',
            },
          },
        ],
        button: {
          title: `+ ${this.$t('static.warehouse.create.title')}`,
          route: {
            name: 'warehouse.create',
          },
        },
      },
    ]);

    accountService.rememberPerPage('get', { from: 'purchase' })
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });

    console.log(this.view);
    if (this.view == 'card') {
      this.info = 'info';
      this.primary = 'primary';
    } else {
      this.primary = 'info';
      this.info = 'primary';
    }
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'purchase', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Fetches paginated purchase.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all: debounce(function (page, limit) {
      this.loading = true;
      purchaseService.items({
        page,
        limit,
        search: this.getSearch(this.limit),
        filter: this.$route.query.filter,
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loadProductsing = false;
      });
    }, 800),

    changeView(view) {
      if (this.info != view) {
        this.primary = this.info;
        this.info = view;
        if (this.info == 'info') {
          store.dispatch('setView', 'card');
        } else {
          store.dispatch('setView', 'list');
        }
      }
    },
    /**
     * Go to edit view for purchase.
     *
     * @param  {Object} purchase The purchase object.
     */
    editAdjustment(purchase) {
      let name = 'inventory.purchase.view';
      if (purchase.status != 'done') {
        name = 'inventory.purchase.edit';
      }
      this.$router.push({
        name,
        params: { id: purchase.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/purchase/index/index.js